module.exports = __webpack_public_path__ + "img/halfrategold.d5ebe4a9.svg";